'use client';

import { useEffect, useCallback } from 'react';

export function useSheetKeyboardNav(
  open: boolean,
  onPrev: () => void,
  onNext: () => void
) {
  const handlePrev = useCallback(() => onPrev(), [onPrev]);
  const handleNext = useCallback(() => onNext(), [onNext]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        handlePrev();
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        handleNext();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, handlePrev, handleNext]);
}
